import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getPromotions} from '../../../apis/promotion/list'

/**
 * banner 가져오기 모달 전용 — active=false 프로모션 목록을 지정 language 헤더로 조회.
 * admin 의 현재 언어 설정과 무관하게 ko/en 을 각각 강제로 가져온다.
 */
const useQueryPromotionsByLang = (language: 'ko' | 'en', enabled: boolean = true) => {
    const {data, refetch, isLoading} = useQuery({
        enabled,
        queryKey: QueryCacheKeys.promotion.getPromotionsByLang(false, language),
        queryFn: async () => {
            const {data} = await getPromotions(false, language)
            return data
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    })
    return {data, refetch, isLoading}
}

export default useQueryPromotionsByLang
